import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAgent = async () => {
      if (token) {
        try {
          const response = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setAgent(response.data);
        } catch (error) {
          console.error('Failed to fetch agent:', error);
          logout();
        }
      }
      setLoading(false);
    };
    fetchAgent();
  }, [token]);

  const login = (newToken, agentData) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
    setAgent(agentData);
  };

  const logout = () => {
    const currentToken = localStorage.getItem('token');
    const adminToken = localStorage.getItem('adminToken');
    if (currentToken) {
      fetch(`${API}/auth/logout`, { method: 'POST', headers: { Authorization: `Bearer ${currentToken}` } }).catch(() => {});
    }
    if (adminToken && adminToken !== currentToken) {
      fetch(`${API}/admin/logout`, { method: 'POST', headers: { Authorization: `Bearer ${adminToken}` } }).catch(() => {});
    }
    localStorage.removeItem('token');
    localStorage.removeItem('adminToken');
    setToken(null);
    setAgent(null);
  };

  return (
    <AuthContext.Provider value={{ token, agent, setAgent, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
